import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import validator from 'validator';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types'; // Import PropTypes
import { toast } from 'react-toastify';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import Input from '../../components/common/InputField';
import './style.css';
import ButtonMain from '../../components/common/ButtonMain';
import { loginUserAPI } from '../../store/features/loginUser';
import { loginUserTenantAPI } from '../../store/features/loginUserTenant';
import LoginTwoFactor from './LoginTwoFactor';
import { resendVerificationAPI } from '../../store/features/resendVerificationEmail';
import SuccessPopup from '../../components/common/SuccessPopup';
import FailurePopup from '../../components/common/FailurePopup';
import PasswordField from '../../components/common/passwordInput';
import { loginCoUserApi } from '../../store/features/loginCoUser';
import { createAppSocket } from '../../api/createAppSocket';
import { useSocket } from '../../SocketContext';

function LoginMain(props) {
  const [showPopup, setShowPopup] = useState(false);

  const navigate = useNavigate();
  const { emailFromSignUp } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const userData = useSelector((state) => state.loginToken);
  const userCoData = useSelector((state) => state.loginTokenCoUser);
  const requiresTwoFactor = useSelector((state) => state.loginToken.requiresTwoFactor);


  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );

  const [stateName, setStateMethod] = useState({
    email: '',
    emailInvalid: false,
    emailInvalidMessage: '',
    password: '',
    passwordnvalidError: '',
    passwordInvalid: false,
    FormSubmitting: false,
    emailState: false,
    passwordState: false,
    emailTouched: false, // Add this flag to track if email field has been touched
  });

  const [tenantLogin, setTenantLogin] = useState(false);
  const [tenantId, setTenantId] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showOkayButton, setShowOkayButton] = useState(true);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [titleOfPopup, setTitleOfPopup] = useState('');
  const [routeTo, setRouteTo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showSuspendPopup, setShowSuspendPopup] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const [cancelButtonText, setCancelButtonText] = useState('');

  const socketRef = useRef();

  useEffect(() => {
    socketRef.current = createAppSocket();

    return () => {
      // socketRef.current.disconnect();
    };
  }, []);

  const onCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };
  const onCloseFailurePopup = () => {
    setShowFailurePopup(false);
    setAlertMessage('');
    setShowOkayButton(true);
    setShowCancelButton(false);
  };

  const ValidateEmail = (email) => {
    if (validator.isEmail(email) === false) {
      return false;
    }
    return true;
  };

  const ValidatePassword = (password) => {
    if (
      validator.isStrongPassword(password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    const tenant_id = parseInt(new URLSearchParams(location.search).get('t_id'));
    if (tenant_id !== null && tenant_id !== undefined && tenant_id !== '' && tenant_id > 0) {
      setTenantLogin(true);
      setTenantId(tenant_id);
    } else {
      setTenantLogin(false);
      setTenantId(0);
    }

    const emaill = emailFromSignUp;
    if (emaill?.length > 0) {
      setStateMethod({
        ...stateName,
        email: emailFromSignUp,
      });
    }
    // Already-authenticated redirects are handled by GuestOnlyRoute (no flash).
  }, [emailFromSignUp, location.search]);


  const handleChange = (event) => {
    const { name, value } = event.target;

    setStateMethod((prev) => {
      const emailValid =
        name === "email" ? ValidateEmail(value) : prev.emailState;
      const passwordValid =
        name === "password" ? ValidatePassword(value) : prev.passwordState;

      return {
        ...prev,
        [name]: value,
        emailState: emailValid,
        passwordState: passwordValid,

        // ✅ clear error when user starts typing again
        ...(name === "email" && {
          emailInvalid: false,
          emailInvalidMessage: "",
        }),
        ...(name === "password" && {
          passwordInvalid: false,
          passwordnvalidError: "",
        }),
      };
    });
  };



  const loginCoUserHandler = async () => {
    dispatch(
      loginCoUserApi({
        requestHeaders: {
          co_user_email: stateName.email,
          co_user_password: stateName.password,
        },
        authToken: userData.response.token,
      }),
    )
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          toast.success(data?.payload?.message);
          navigate('/dashboad');
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 400) {
          toast.error(data.payload.message, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  const EnableHandler = () => {
    const isEmailValid = ValidateEmail(stateName.email);
    const isPasswordValid = ValidatePassword(stateName.password);

    if (!isEmailValid || !isPasswordValid) {
      // ❌ Invalid case → show errors, don't set loading
      setStateMethod((prev) => ({
        ...prev,
        emailInvalid: !isEmailValid,
        emailInvalidMessage: !isEmailValid ? t.EMAILERROR : "",
        passwordInvalid: !isPasswordValid,
        passwordnvalidError: !isPasswordValid ? t.PASSERROR : "",
      }));
      return; // stop login if invalid
    }

    // ✅ Valid case → now set loading
    setIsLoading(true);

    // Continue with login
    if (tenantLogin && tenantId > 0) {
      loginTenantUserHandler();
    } else {
      loginMasterUserHandler();
    }
  };



  const loginTenantUserHandler = async () => {
    if (stateName.emailState && stateName.passwordState) {
      const { email, password } = stateName;
      const loginUserDispatcher = dispatch(
        loginUserTenantAPI({
          t_id: tenantId,
          co_user_email: email,
          co_user_password: password,
          rememberMe,
        }),
      );

      try {
        const response = await loginUserDispatcher;

        if (!response || typeof response.payload === 'undefined') {
          setAlertMessage('Sorry, an error has occurred. Please try again. If the issue persists, please contact customer support.');
          setShowFailurePopup(true);
          setIsLoading(false);
        } else if (response.payload.status === 401) {
          setStateMethod({
            ...stateName,
            passwordnvalidError: response.payload.message || 'Invalid password',
            passwordInvalid: true,
          });
          setIsLoading(false);
        } else if (response.payload.status === 404) {
          setAlertMessage('No user found. Please try again with correct email & password.');
          setTitleOfPopup('Zero Matching Accounts Found');
          setShowCancelButton(true);
          setCancelButtonText('Signup as new?');
          setRouteTo('register');
          setShowFailurePopup(true);
          setIsLoading(false);
        } else if (response.payload.status === 200) {
          setIsLoading(false);
          navigate('/dashboard');
          return true;
        } else if (response.payload.status === 400) {
          if (response?.payload?.passwordCheck === false) {
            setStateMethod({
              ...stateName,
              passwordnvalidError: 'The password you have entered is incorrect',
              passwordInvalid: true,
            });
            setIsLoading(false);
          }

          if (response?.payload?.emailVerified === false) {
            setAlertMessage(`Please verify your account by clicking the link sent on your email address e.g. ${email}.`);
            setTitleOfPopup('Email Not Verified');
            setShowCancelButton(true);
            setCancelButtonText('Not received email? Resend');
            setShowFailurePopup(true);
            setRouteTo('resendEmail');
            setIsLoading(false);
          }
        }
      } catch (error) {
        setAlertMessage(error.message);
        setShowFailurePopup(true);
        setRouteTo('login');
        setIsLoading(false);
      }
    }
  };


  const loginMasterUserHandler = async () => {
    if (stateName.emailState && stateName.passwordState) {
      const { email, password } = stateName;
      const authToken = userData?.response?.token || userCoData?.response?.token || null;


      const loginUserDispatcher = dispatch(
        loginUserAPI({
          email,
          password,
          rememberMe,
        }),
      );
      loginUserDispatcher
        .then(async (response) => {
          if (!response || typeof response.payload === 'undefined') {
            setAlertMessage('Sorry, an error has occurred. Please try again. If the issue persists, please contact customer support.');
            setShowFailurePopup(true);
            setIsLoading(false);
          } else if (response.payload.status === 401) {
            setStateMethod({
              ...stateName,
              passwordnvalidError: response.payload.message || 'Invalid password',
              passwordInvalid: true,
            });
            setIsLoading(false);
          } else if (response.payload.status === 404) {
            setAlertMessage('No user found. Please try again with correct email & password.');
            setTitleOfPopup('Zero Matching Accounts Found');
            setShowCancelButton(true);
            setCancelButtonText('Signup as new?');
            setRouteTo('register');
            setShowFailurePopup(true);
            setIsLoading(false);
          } else if (response.payload.status === 200) {
            if (response.payload.requiresTwoFactor) {
              setIsLoading(false);
              return true;
            }

            // Emit socket event
            socketRef.current.emit("login-agent", response.payload?.user?._id);


            setIsLoading(false);
            return true;
          } else if (response.payload.status === 400) {
            if (response?.payload?.passwordCheck === false) {
              setStateMethod({
                ...stateName,
                passwordnvalidError: 'The password you have entered is incorrect',
                passwordInvalid: true,
              });
              setIsLoading(false);
            }

            if (response?.payload?.emailVerified === false) {
              setAlertMessage(`Please verify your account by clicking the link sent on your email address e.g. ${email}.`);
              setTitleOfPopup('Email Not Verified');
              setShowCancelButton(true);
              setCancelButtonText('Not received email? Resend');
              setShowFailurePopup(true);
              setRouteTo('resendEmail');
              setIsLoading(false);
            }
          } else if (response.payload.status === 403 && !response.payload.business_status && !response.payload.business_status === 'suspended' && !response.payload.business_status === 'banned') {
            setAlertMessage('We sent a verification link to your email. Please verify to continue. If you did not receive it, you can resend the verification email.');
            setTitleOfPopup('Please verify your email address');
            setShowCancelButton(true);
            setCancelButtonText('Resend email');
            setRouteTo('resendEmail');
            setShowFailurePopup(true);
            setIsLoading(false);
            setShowSuspendPopup(false);
          } else if (response.payload.status === 409) {
            setAlertMessage('Your session limit is full. Please logout of other devices or reset your password')
            setTitleOfPopup('Session Limit Reached');
            setShowCancelButton(true);
            setCancelButtonText('Reset Password');
            setRouteTo('resetPassword');
            setShowFailurePopup(true);
            setIsLoading(false);
            setShowSuspendPopup(false);
          } else if (response.payload.business_status === 'suspended') {
            setAlertMessage('This business is suspended. All members (admins and agents) cannot sign in. Contact support.')
            setTitleOfPopup('Account Suspended');
            setShowFailurePopup(true);
            setIsLoading(false);
          }else if (response.payload.business_status === 'banned') {
            setAlertMessage('This business is banned. All members (admins and agents) cannot sign in. Contact support')
            setTitleOfPopup('Account Banned');
            setShowFailurePopup(true);
            setIsLoading(false);
          }
          return false;
        })
        .catch((error) => {
          setAlertMessage(error.message);
          setShowFailurePopup(true);
          setRouteTo('login');
          setIsLoading(false);
        });
    }
  }

  const cancelButtonAction = async () => {
    const route = routeTo;
    if (route === 'resetPassword') {
      navigate('/forget-password');
    } else {
      
    }
    if (route === 'register') {
      navigate(
        '/',
        {
          state: {
            takenEmail: stateName.email,
          },
        },
      );
    } else if (route === 'login') {
      setShowFailurePopup(false);
      navigate('/login');
    } else if (route === 'forget') {
      navigate(
        '/forget-password',
        {
          state: {
            takenEmail: stateName.email,
          },
        },
      );
    } else if (route === 'resendEmail') {
      const { email } = stateName;
      const resendDispatcher = dispatch(
        resendVerificationAPI({
          email,
        }),
      );
      resendDispatcher
        .then(async (response) => {
          if (response.payload.status === 200) {
            setShowSuccessPopup(false);
            setShowFailurePopup(false);
            setShowCancelButton(false);
            const settingMessage = Promise.resolve(setAlertMessage('Email has been resent successfully.'));
            settingMessage.then(() => {
              setTitleOfPopup('Email Resent.');
              setShowSuccessPopup(true);
            });
          } else {
            const settingMessage = Promise.resolve(setAlertMessage('Sorry, an error has occurred. Please try again. If the issue persists, please contact customer support.'));
            settingMessage.then(() => {
              setShowFailurePopup(true);
              setIsLoading(false);
            });
          }
        });
    }
  };
  const handleTwoFactorVerified = (payload) => {
    socketRef.current.emit('login-agent', payload?.user?._id);
  };

  if (requiresTwoFactor) {
    return (
      <LoginTwoFactor
        rememberMe={rememberMe}
        onVerified={handleTwoFactorVerified}
      />
    );
  }

  return (
    <>
      <div className="adminPanelMainDiv__login">
        {/* Popups */}
        <SuccessPopup
          show={showSuccessPopup}
          description={alertMessage}
          showOkayButton={showOkayButton}
          showCancelButton={showCancelButton}
          onOkay={onCloseSuccessPopup}
          cancelText={cancelButtonText}
          onCancel={cancelButtonAction}
          displayText={titleOfPopup}
        />
        <FailurePopup
          show={showFailurePopup}
          description={alertMessage}
          showOkayButton={showOkayButton}
          showCancelButton={showCancelButton}
          onOkay={onCloseFailurePopup}
          cancelText={cancelButtonText}
          onCancel={cancelButtonAction}
          displayText={titleOfPopup}
          showSuspend={showSuspendPopup}
        />
        {/* Popups */}
        <div className="inputDivStyle-login">
          <div className="textDiv__login">
            <p className="text__create">{t.LOGIN_MSG}</p>
            <p className="text__start">{t.LOGIN_WLCM_MSG}</p>
          </div>
          <Input
            name="email"
            id="email"
            type="email"
            title={t.TITLE_EMAIL}
            placeholder={t.ENTR_EML_PH}
            value={stateName.email}
            onChange={(e) => handleChange(e)}
            error={stateName.emailInvalidMessage}
            className={clsx(
              stateName.emailInvalid ? 'input__error' : '',
              stateName.emailState ? 'input__success' : '',
            )}
          />
          <br />
          <PasswordField
            name="password"
            id="password"
            type="password"
            title={t.ENTR_PWD}
            placeholder={t.ENTR_PASS_PH}
            value={stateName.password}
            onChange={(e) => handleChange(e)}
            error={stateName.passwordnvalidError}
            className={clsx(
              stateName.passwordInvalid ? 'input__error' : '',
              stateName.passwordState ? 'input__success' : '',
            )}
          />

          {showPopup && (
            <FailurePopup
              displayText="Error!"
              description="Error Message"
              okayText="Okay"
              cancelText="Cancel"
              onCancel={() => setShowPopup(false)}
            />

          )}
          <div className="check__box">
            <div className="block__check">
              <input
                type="checkbox"
                className="custom-checkbox"
                id="myCheckbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="myCheckbox">
                <span className="Remember__01">{t.RMMBR_MSG}</span>
              </label>
            </div>
            <Link
              to="/forget-password"
              style={{ textDecoration: 'none', paddingLeft: '5px', marginBottom: "5px" }}
            >
              <p className="forget__passtext">{t.FGT_PWD}</p>
            </Link>
          </div>
          <div className="btn-class">
            <ButtonMain
              title={isLoading ? t.BTN_LOADING : t.SIGNIN}
              onClick={EnableHandler}
              className={
                stateName.email?.trim() && stateName.password?.trim() && !isLoading
                  ? "buttonStyleEnable"
                  : "buttonStyleDisabled"
              }
              disabled={!(stateName.email?.trim() && stateName.password?.trim()) || isLoading}
            />
            <p className="a__singIn">
              {t.DONT_HAVE_ACC}
              <Link
                to="/"
                style={{ textDecoration: 'none', paddingLeft: '5px' }}
              >
                <span className="b__signIn">{t.SIGNUP}</span>
              </Link>
            </p>
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </>
  );
}
LoginMain.propTypes = {
  emailFromSignUp: PropTypes.string.isRequired, // Adjust the type accordingly
};
export default LoginMain;
